export default __webpack_public_path__ + "static/ASLA_Radia_2-f1691b0424c73ee7f4d5e59aff0c7b5e.png";